import React from 'react';

const Info = ({sheet}) => {
  return (
    <section id="info">
    <h3>Info</h3>
    <div className="row-fluid">
      <div className="span4">
        <div className="field" id="application-container" data-children-count="1">
          <label htmlFor="application">Type of sheet</label>
          <select name="application" id="application" size="10">
            <option value="volunteer_work">Volunteer Work</option>
            <option value="potluck">Potluck</option>
            <option value="one_on_ones">Individual Sessions / Auditions</option>
            <option value="group_meetings">Group Activity / Training</option>
            <option value="donations">Donations or Supplies</option>
            <option value="performer_slots">Performer / Presenter Slots</option>
            <option value="resource_reservations">Resource Reservations</option>
            <option value="topics">Assignment Topics</option>
            <option value="other">Other</option>
          </select>
        </div>
      </div>
      <div className="span4">
        <div className="field" id="role-container" data-children-count="1">
          <label htmlFor="role">Type of organization</label>
          <select name="role" id="role" size="10">
            <option value="comedy">Comedy</option>
            <option value="higher_ed">Higher Education</option>
            <option value="food_ordering">Food Ordering</option>
            <option value="business">Business</option>
            <option value="k12">K-12 Education</option>
            <option value="non_profit">Non Profit</option>
            <option value="group">Club, Group or Team</option>
            <option value="arts">Performing Arts</option>
            <option value="politics">Elecoral Politics</option>
            <option value="religious">Religious</option>
            <option value="personal">Personal &amp; Family</option>
            <option value="other">Other</option>
          </select>
        </div>
      </div>
    </div>
  </section>
  );
};

export default Info;
